import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackFlatViewOrderPopupOpen, trackFlatViewOrderSuccess } from './tracking';
import {
  addFlatTourBooking,
  getFlatTourSchedule as getFlatTourScheduleThunk,
} from '../../../browser/services/flatTourBooking';
import { FlatViewButton } from '../../components/FlatViewButton';
import { canMakeFlatViewOrder, getOfferUserId } from '../../selectors';
import { getIsFlatTourAvailable, getFlatTourSchedule } from '../../selectors/flatTourBooking';
import { getNewbuildingId, getNewbuildingName } from '../../selectors/newObject';

export function FlatViewButtonContainer() {
  const [isBookingWidgetOpened, setIsBookingWidgetOpen] = React.useState(false);

  const dispatch = useDispatch();
  const isEnabled = useSelector(canMakeFlatViewOrder);
  const isTourAvailable = useSelector(getIsFlatTourAvailable);
  const newbuildingName = useSelector(getNewbuildingName);
  const newbuildingId = useSelector(getNewbuildingId);
  const builderUserId = useSelector(getOfferUserId);
  const schedule = useSelector(getFlatTourSchedule);

  React.useEffect(() => {
    if (isEnabled) {
      dispatch(getFlatTourScheduleThunk());
    }
  }, [dispatch, isEnabled]);

  const handleOpenModal = React.useCallback(() => {
    trackFlatViewOrderPopupOpen();
    setIsBookingWidgetOpen(true);
  }, []);

  const handleCloseModal = React.useCallback(() => {
    setIsBookingWidgetOpen(false);
  }, []);

  const handleSubmit = React.useCallback(
    async (params: ICallbackParams) => {
      try {
        const bookingParams = {
          newbuildingId: newbuildingId as number,
          builderUserId: builderUserId as number,
          fullName: params.name,
          phone: params.phone,
          tourTime: `${params.date} ${params.time}`,
        };

        // eslint-disable-next-line @typescript-eslint/await-thenable
        await dispatch(addFlatTourBooking(bookingParams));

        return true;
      } catch {
        return false;
      }
    },
    [dispatch, builderUserId, newbuildingId],
  );

  const handleSuccessSubmit = React.useCallback((params: ICallbackParams) => {
    trackFlatViewOrderSuccess(params);
  }, []);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <FlatViewButton onClick={handleOpenModal} disabled={!isTourAvailable} />
      {schedule && (
        <FlatViewOrderSinglePageDesktop
          isOpen={isBookingWidgetOpened}
          onClose={handleCloseModal}
          onSuccess={handleSuccessSubmit}
          onSubmit={handleSubmit}
          newbuildingName={`ЖК «${newbuildingName}»`}
          nextDate={schedule.nextDate}
          nextNextDate={schedule.nextNextDate}
          availableDates={schedule.availableDates}
          disabledDays={schedule.disabledDays}
          minDate={schedule.minDate}
          maxDate={schedule.maxDate}
        />
      )}
    </>
  );
}
